import Vue from 'vue'
import Router from 'vue-router'

// Containers
import Full from '@/containers/Full'

// Views
import Login from '@/views/admin/Login'
import PasswordReset from '@/views/admin/PasswordReset'
import Dashboard from '@/views/admin/Dashboard'
import AclGroups from '@/views/admin/acl_groups/Win'
import Acl from '@/views/admin/acl/Acl'
import Translator from '@/views/admin/Translator'
import Languages from '@/views/admin/languages/Win'
import SiteProps from '@/views/admin/SiteProps'
import EmailTemplates from '@/views/admin/EmailTemplates'
import UserCompanies from '@/views/admin/companies/Win'
import UserSubCompanies from '@/views/admin/subcompanies/Win';
import Users from '@/views/admin/users/Win'
import Generator from '@/views/admin/Generator'

//Flow
import Flow from '@/views/flow_operator_obligations/Win'
import Step from '@/views/flow_operator_obligations/step/Win'
import StepButtons from '@/views/flow_operator_obligations/step/step_button/Win'
import Questions from '@/views/flow_operator_obligations/step/questions/Win'

//FlowSec
import FlowSec from '@/views/flow_traffic_safety_managment/WinSec'
import StepSec from '@/views/flow_traffic_safety_managment/step/Win'
import StepButtonsSec from '@/views/flow_traffic_safety_managment/step/step_button/Win'
import QuestionsSec from '@/views/flow_traffic_safety_managment/step/questions/Win'

//Building detail
import BuildingDetail from '@/views/building_detail/Win'
import ObjectDetails from '@/views/object_details/Win'

//Job
import Job from '@/views/job/Win'
import Answers from '@/views/job/AnswersWin'

//JobRecurring
import JobRecurring from '@/views/job_recurring/Win'

//NotificationCenter
import NotificationCenter from '@/views/notification_center/Win'

// Check list
import CheckList from '@/views/check_list/CheckListWin'
import CheckListItems from '@/views/check_list/CheckListItemsWin'

//GENERATORLASTITEM

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location)
{
    return originalPush.call(this, location).catch((err) =>
    {
        if (err.name !== 'NavigationDuplicated')
        {
            throw err;
        }
    });
};

Vue.use(Router);

export default new Router({
	mode: 'history',
  base: '/admin/',
	routes:
	[
		{
      path: '/dashboard',
      name: 'HOME',
      component: Full,
      children: [
        {
          path: '',
          name: 'DASHBOARD',
          component: Dashboard
        }
			]
    },
    {
      path: '/job',
      name: 'Job',
      component: Full,
      children: [
          {
              path: '',
              name: 'JOB',
              component: Job
          },
          {
            path: ':jobId/answers',
            name: 'ANSWERS',
            component: Answers,
        }
      ],
    },
    {
      path: '/job_recurring',
      name: 'JobRecurring',
      component: Full,
      children: [
          {
              path: '',
              name: 'JOBRECURRING',
              component: JobRecurring
          },
      ],
    },
    {
      path: '/notification_center',
      name: 'NotificationCenter',
      component: Full,
      children: [
          {
              path: '',
              name: 'NOTIFICATIONCENTER',
              component: NotificationCenter
          },
      ],
    },
    {
      path: '/flowsec',
      name: 'FLOWSEC',
      component: Full,
      children: [
          {
              path: '',
              name: 'FLOWSEC',
              component:
              {
                  render(c)
                  {
                      return c('router-view');
                  },
              },
              children: [
                  {
                      path: '',
                      name: 'FLOWSEC',
                      component: FlowSec,
                  },
                  {
                    path: '',
                    name: 'STEP',
                    component:
                    {
                        render(c)
                        {
                            return c('router-view');
                        },
                    },
                    children: [
                        {
                            path: 'step/:flowId',
                            name: 'STEP',
                            component: StepSec,
                        },
                        {
                            path: 'step/:flowId/step_buttons/:stepId',
                            name: 'STEPBUTTONS',
                            component: StepButtonsSec,
                        },
                        {
                            path: 'step/:flowId/questions/:stepId',
                            name: 'QUESTIONS',
                            component: QuestionsSec,
                        }]
                  }],
          },
      ],
    },
    {
      path: '/flow',
      name: 'FLOW',
      component: Full,
      children: [
          {
              path: '',
              name: 'FLOW',
              component:
              {
                  render(c)
                  {
                      return c('router-view');
                  },
              },
              children: [
                  {
                      path: '',
                      name: 'FLOW',
                      component: Flow,
                  },
                  {
                    path: '',
                    name: 'STEP',
                    component:
                    {
                        render(c)
                        {
                            return c('router-view');
                        },
                    },
                    children: [
                        {
                            path: 'step/:flowId',
                            name: 'STEP',
                            component: Step,
                        },
                        {
                            path: 'step/:flowId/step_buttons/:stepId',
                            name: 'STEPBUTTONS',
                            component: StepButtons,
                        },
                        {
                            path: 'step/:flowId/questions/:stepId',
                            name: 'QUESTIONS',
                            component: Questions,
                        }]
                  }],
          },
      ],
    },
    {
      path: '/building_detail',
      name: 'BuildingDetail',
      component: Full,
      children: [
          {
              path: '',
              name: 'BUILDINGDETAIL',
              component: BuildingDetail
          },
      ],
    },
    {
      path: '/check_list',
      name: 'CheckList',
      component: Full,
      children: [
          {
              path: '',
              name: 'CHECKLIST',
              component: CheckList
          },
          {
              path: ':checkListId',
              name: 'CHECKLISTITEMS',
              component: CheckListItems,
          },
      ],
    },
    {
      path: '/object_details',
      name: 'ObjectDetails',
      component: Full,
      children: [
          {
              path: '',
              name: 'OBJECTDETAILS',
              component: ObjectDetails
          },
      ],
    },
		{
      path: '/system',
      name: 'SYSTEM',
      component: Full,
      children: [
        {
          path: 'aclgroups',
          name: 'ACLGROUPS',
          component: AclGroups
        },
        {
          path: 'acl',
          name: 'ACL',
          component: Acl
        },
				{
          path: 'translator',
          name: 'TRANSLATOR',
          component: Translator
        },
				{
          path: 'languages',
          name: 'LANGUAGES',
          component: Languages
        },
				{
          path: 'siteprops',
          name: 'SITEPROPS',
          component: SiteProps
        },
				{
          path: 'emailtemplates',
          name: 'EMAILTEMPLATES',
          component: EmailTemplates
        },
				{
          path: 'usercompanies',
          name: 'USERCOMPANIES',
          component: UserCompanies
        },
        {
          path: 'usersubcompanies',
          name: 'USERSUBCOMPANIES',
          component: UserSubCompanies
        },
				{
          path: 'users',
          name: 'USERS',
          component: Users
        },
				{
          path: 'generator',
          name: 'GENERATOR',
          component: Generator
        }//GENERATORINSERT
			]
		},
		{
      path: '/login/reset/:verifyCode',
      name: 'PASSWORDRESET',
      component: PasswordReset
    },
    {
      path: '/login',
      name: 'LOGIN',
      component: Login
    }
	]
})
